import React from 'react'
import { observer } from 'mobx-react'
import classnames from 'classnames'

// Display an icon using <use> as described at
// https://css-tricks.com/svg-symbol-good-choice-icons/
const Icon = ({ id, onClick, extraClasses = [], style }) => {
  return (
    <svg
      key={id}
      onClick={onClick}
      className={classnames('icon', ...extraClasses)}
      style={style}
    >
      <use xlinkHref={`#${id}`} />
    </svg>
  )
}

export default observer(Icon)
